import { API } from '@aws-amplify/api';
import { SurveyAnswerInput } from '../../@types/subjectSurvey';

export interface SaveSubjectSurveyAnswersInput {
  studentId: string;
  subject: string;
  answers: SurveyAnswerInput[];
}

export interface SaveSubjectSurveyAnswersResponse {
  message: string;
}

export async function saveSubjectSurveyAnswers(
  input: SaveSubjectSurveyAnswersInput
): Promise<SaveSubjectSurveyAnswersResponse> {
  try {
    const apiName = process.env.NEXT_PUBLIC_ONBOARDING_API_NAME!;
    const path = 'api/subject-survey/answers';
    const myInit = {
      headers: {},
      body: input,
    };

    const response = await API.post(apiName, path, myInit);
    return response;
  } catch (error) {
    console.error('Error saving subject survey answers:', error);
    throw error;
  }
}
